import { render, staticRenderFns } from "./scroll-down.vue?vue&type=template&id=64f299f3&scoped=true&"
import script from "./scroll-down.vue?vue&type=script&lang=js&"
export * from "./scroll-down.vue?vue&type=script&lang=js&"
import style0 from "./scroll-down.vue?vue&type=style&index=0&id=64f299f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f299f3",
  null
  
)

export default component.exports